import { CobaltDatePicker } from '@cae/cobalt-react/components/date-picker';
import { CobaltToggletip } from '@cae/cobalt-react/components/toggletip';
import { CobaltIconInfoCircleSolid } from '@cae/cobalt-react/icons/solid/CobaltIconInfoCircleSolid';
import * as React from 'react';

import type { EditIdentityBirthdateFieldProps } from './EditIdentityBirthdateField.types';

import styles from './EditIdentityBirthdateField.module.css';

const EditIdentityBirthdateField = React.memo(
  ({
    value,
    error,
    disabled,
    onDateSelect,
    onChange,
  }: Readonly<EditIdentityBirthdateFieldProps>): React.ReactElement => {
    const [anchorElement, setAnchorElement] = React.useState<HTMLElement | null>(null);

    const handleToggletipClose = React.useCallback((): void => {
      setAnchorElement(null);
    }, []);

    const handleToggletipClick = React.useCallback(
      (event: React.MouseEvent<HTMLButtonElement>): void => {
        if (anchorElement) {
          handleToggletipClose();
        } else {
          setAnchorElement(event.currentTarget);
        }
      },
      [anchorElement, handleToggletipClose]
    );

    return (
      <div data-heap-id="birthdate-field">
        <div className={styles.datePickerLabel}>
          <span id="birthdate-label">Date of birth</span>
          <button
            type="button"
            data-heap-id="profile-identity-birthdate-info-btn"
            aria-label="Date of birth information"
            className={styles.tooltipTrigger}
            onClick={handleToggletipClick}
            disabled={disabled}
          >
            <CobaltIconInfoCircleSolid size="small" aria-hidden="true" />
          </button>
          <CobaltToggletip
            title="Date of birth"
            description="Your date of birth helps us verify your identity and meet regulatory requirements."
            anchorEl={anchorElement}
            isOpen={Boolean(anchorElement)}
            onToggle={handleToggletipClose}
            position="bottom-start"
            className={styles.editIdentityBirthdateToggletip}
          >
            <span />
          </CobaltToggletip>
        </div>
        <CobaltDatePicker
          id="birthdate"
          data-heap-id="profile-identity-birthdate"
          aria-labelledby="birthdate-label"
          hasClear
          dateFormat="dd-MM-yyyy"
          placeholder="DD-MM-YYYY"
          value={value}
          onDateSelect={onDateSelect}
          onChange={onChange}
          error={error}
          disabled={disabled}
        />
      </div>
    );
  }
);

EditIdentityBirthdateField.displayName = 'EditIdentityBirthdateField';
export { EditIdentityBirthdateField };
